import { Card, CardContent, Grid, SxProps, Theme, Typography } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";

export const Overview = () => {
  return (
    <SectionContainer sx={{ background: "white" }}>
      <SectionTitle>TASができること</SectionTitle>
      <Grid container spacing={4} sx={gridSx}>
        <Grid item xs={12} md={4}>
          <Card sx={cardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                最適なチーム構成
              </Typography>
              <Typography variant="body1" sx={cardDescriptionSx}>
                副業人材と専業人材を組み合わせた開発チームを、案件規模や状況に応じて適切に配置します。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={cardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                安定した開発体制
              </Typography>
              <Typography variant="body1" sx={cardDescriptionSx}>
                専業人材がコアとなり、副業人材の特性を活かした柔軟で安定した開発体制をサポートします。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={cardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                高品質な開発
              </Typography>
              <Typography variant="body1" sx={cardDescriptionSx}>
                様々な知見を持つ優秀な副業人材をチームに採用することによって、難しい設計課題などもエンジニアの知見を組み合わせて解決できます。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

const gridSx: SxProps<Theme> = {
  justifyContent: "center",
};

const cardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
  "&:hover": {
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.15)",
  },
});

const cardContentSx: SxProps<Theme> = {
  padding: "32px",
  textAlign: "center",
};

const cardTitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "24px",
  fontWeight: 600,
  marginBottom: "16px",
  color: "#22A1B9",
});

const cardDescriptionSx: SxProps<Theme> = {
  fontSize: "16px",
  lineHeight: 1.6,
  color: "#666666",
  textAlign: "left",
};
